/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeDRadiusUpLeftIcon20Solid = forwardRef('ArrowShapeDRadiusUpLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 2.957c0-1.114-1.346-1.672-2.134-.884l-6.69 6.69a1.75 1.75 0 0 0 0 2.474l6.69 6.69c.788.787 2.134.23 2.134-.884V14c1.32.006 2.358.054 3.394.395 1.14.375 2.343 1.132 3.866 2.746.575.609 1.692.293 1.728-.64.14-3.695-.916-6.355-2.738-8.085-1.687-1.601-3.94-2.32-6.25-2.408V2.957Z" })));
});
